import { render, staticRenderFns } from "./MemberSetting.vue?vue&type=template&id=d70c1b12&"
import script from "./MemberSetting.vue?vue&type=script&lang=js&"
export * from "./MemberSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports